// Returns Mon=0 … Sun=6 for a "YYYY-MM-DD" date string, matching the
// day_of_week convention used by LessonSeries/lesson_series_emails.
export function dayOfWeekFromDate(dateStr) {
  try {
    const [y, m, d] = dateStr.split('-').map(Number)
    const js = new Date(y, m - 1, d).getDay()
    return js === 0 ? 6 : js - 1
  } catch {
    return 0
  }
}